import { Card, Container, Input, FormButton, Text, Checkbox, Box} from "../components/UI"
import { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { useUserData } from "../hooks/useUserData";
import { useController } from "../hooks/useController";
import { Classes } from "../theme/Classes";
import { APP_SETTINGS } from "../hooks/useAppSettings";


export const ResetPasswordStep1 = () => {
    const { handleSubmit, control, formState: { errors }, getValues } = useForm({ mode: 'onChange' });
    const [message,setMessage] = useState('');
    const {lang} = useUserData();
    const {postData: sendResetLink, data: sendResetLinkData, response: sendResetLinkResponse, error: sendResetLinkError} = useController();
    const onSubmit =  async data => {
        await sendResetLink( `${APP_SETTINGS.api}/Account/ResetPasswordStep1?email=${data.email}`, 'POST');
     
    }
    useEffect(()=>{
        if(sendResetLinkResponse?.ok && sendResetLinkResponse)
        {
          setMessage("A reset link has been sent to your account")
        }
        else {
            if(sendResetLinkResponse)
            setMessage("Your email is not registered.")
        }
    },[sendResetLinkData,sendResetLinkResponse])
    
    
    return (
        <Container>
            <Box display="columnCenter">
            <Card>
                <Text role="h1">{lang?.resetPassword1}</Text>
            
                <Controller
                            name="email"
                            control={control}
                            rules={{
                                required: true,
                                pattern: {
                                    value: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,
                                    message: lang?.invalidEmail
                                }
                            }}
                            render={({ field }) => <Input props={field} placeholder={lang?.enterYourRegisteredEmail} />
                            }
                        />
                        {errors.email && errors.email.type === "required" && (
                            <Text role="validationMessage">{lang?.emailRequired}.</Text>
                        )}
                        {errors.email && errors.email.type !== "required" && (
                            <Text role="validationMessage">{errors.email.message}</Text>
                         )}
                        <button style={{...Classes.Button.Secondary}} title="Log In" onClick={handleSubmit(onSubmit)}>
                        {lang?.sendResetLink}
                    </button>
                    <p style={{color:'white'}}>{message != '' && message}</p>
                
                
            </Card>
            </Box>
        </Container>
    )
}